import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { DATE_FORMATS } from "../../../../../constants";
import SvgIcon from "../../../../../parts/SvgIcon";
import submit from "submit-form";
import { CopyComponent } from "../../../../../parts/CopyComponent";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

export const Header = ({
  date,
  mobile = false,
  program,
  handleSelectDate,
  selectedDates,
  handleRemoveMultiple,
  dayString,
  removing,
}) => (
  <div className="day-header">
    <SvgIcon
      className="cursor-pointer"
      onClickFn={(e) => handleSelectDate(e, dayString)}
      src={
        selectedDates.includes(dayString)
          ? "/img/new-icons/checked-square.svg"
          : "/img/new-icons/unchecked-square.svg"
      }
      noFilterOnLight={selectedDates.includes(dayString)}
    />
    <p className="s1">{mobile ? date.format("MMMM Do") : date.format("D")}</p>
    {mobile && program.name && <p>{program.name}</p>}
    {mobile && (
      <FloatingHeader
        handleSelectDate={handleSelectDate}
        selectedDates={selectedDates}
        handleRemoveMultiple={handleRemoveMultiple}
        date={date}
        dayString={dayString}
        removing={removing}
      />
    )}
  </div>
);

export const FloatingHeader = ({
  dayString,
  date,
  handleRemoveMultiple,
  removing,
  exercises,
  athlete,
  handleRefDraggable,
  sections,
}) => {
  const [opened, setOpened] = useState(false);
  const { t } = useTranslation("athlete-portal");

  return (
    <div className="floating-header" style={{ opacity: removing ? 0 : 1, pointerEvents: removing ? 'none' : 'auto' }}>
      <div className="more">
          <input type="radio" name="more" id={`more-${dayString}`} />
          <CopyComponent
            exercises={exercises}
            athlete={athlete}
            sections={sections}
          />
          <div
            className="drag-icon cursor-grab mobile-hidden"
            ref={handleRefDraggable}
            role="div"
          >
            <img src="/img/new-icons/drag-outline.svg" alt={t("calendar.monthDay.view")} />
          </div>
          <details role="list" open={opened}>
            <summary
              onClick={(e) => {
                e.preventDefault();
                setOpened(!opened);
              }}
              onBlur={(e) => {
                e.preventDefault();
                setOpened(false);
              }}
              aria-haspopup="listbox"
              className="p-0! h-auto!"
            >
              <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
            </summary>
            <ul role="listbox" className={opened ? "opened" : ""}>
              <li
                onMouseDown={() => {
                  submit(`/actions/refresh?`, {
                    method: "GET",
                    body: {
                      view: "day",
                      date: date.format(DATE_DAY_FORMAT),
                    },
                  });
                }}
              >
                <a>{t("calendar.monthDay.view")}</a>
              </li>
              <li
                onMouseDown={() => {
                  submit(`/actions/refresh?`, {
                    method: "GET",
                    body: {
                      "modal[type]": "calendar-move-workout",
                      day: date.format(DATE_DAY_FORMAT),
                    },
                  });
                }}
              >
                <a>{t("calendar.monthDay.move")}</a>
              </li>
              <li
                onMouseDown={() => {
                  submit(`/actions/refresh?`, {
                    method: "GET",
                    body: {
                      "modal[type]": "calendar-shift-workout",
                      day: date.format(DATE_DAY_FORMAT),
                    },
                  });
                }}
              >
                <a>{t("calendar.monthDay.shift")}</a>
              </li>
              <li
                onMouseDown={() => {
                  submit(`/actions/refresh?`, {
                    method: "GET",
                    body: {
                      "modal[type]": "calendar-duplicate-workout",
                      day: date.format(DATE_DAY_FORMAT),
                    },
                  });
                }}
              >
                <a>{t("calendar.monthDay.duplicate")}</a>
              </li>
              <li onMouseDown={(e) => handleRemoveMultiple(e, date)}>
                <a className="text-(--danger)!">{t("calendar.monthDay.remove")}</a>
              </li>
            </ul>
          </details>
        </div>
    </div>
  );
};
